import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Upcomingevent.css';

function Upcomingevent() {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);

  useEffect(() => {
    let isMounted = true;
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.eventhouse.in';

    const loadEvents = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/v1/public/events`);
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.message || 'Failed to load events');
        }
        const items = Array.isArray(data.events) ? data.events : [];
        const sorted = [...items].sort((a, b) => {
          const aTime = a?.date ? new Date(a.date).getTime() : 0;
          const bTime = b?.date ? new Date(b.date).getTime() : 0;
          return aTime - bTime;
        });
        if (isMounted) {
          setEvents(sorted.slice(0, 3));
        }
      } catch (error) {
        console.error('Failed to load events', error);
      }
    };

    loadEvents();

    return () => {
      isMounted = false;
    };
  }, []);

  const formatDateParts = (value) => {
    if (!value) return { date: '--', day: '', month: '' };
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return { date: '--', day: '', month: '' };
    const dateNumber = date.toLocaleDateString('en-US', { day: '2-digit' });
    const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });
    const monthName = date.toLocaleDateString('en-US', { month: 'short' });
    return { date: dateNumber, day: dayName, month: monthName };
  };

  const formatTime = (value) => {
    if (!value) return '';
    if (/^\d{1,2}:\d{2}$/.test(value)) {
      const [hours, minutes] = value.split(':').map(Number);
      const tempDate = new Date();
      tempDate.setHours(hours, minutes, 0, 0);
      return tempDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    }
    return value;
  };

  const formatVenue = (event) => {
    const primary = event?.venue || '';
    const cityState = [event?.city, event?.state].filter(Boolean).join(', ');
    const fullText = [primary, cityState].filter(Boolean).join(' ');
    const words = fullText.trim().split(/\s+/).filter(Boolean);
    if (words.length <= 2) return fullText;
    return `${words.slice(0, 2).join(' ')}...`;
  };

  const handleBookSlot = (eventId) => {
    if (!eventId) return;
    navigate(`/Singleeventdetails/${eventId}`);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  const handleSeeAll = () => {
    navigate('/events');
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <section className="upcoming-section">
      <div className="upcoming-container">
        <div className="upcoming-badgee">Upcoming Experiences</div>
        
        <p className="upcoming-subtitle">
          Thoughtfully curated experiences.<br />
          Designed for real connections, meaningful conversations, and memorable moments.
        </p>

        <div className="events-wrapper">
          <div className="event-schedule-text">
            EVENT <br /> SCHEDULE
          </div>
          
          <div className="events-list">
            {events.map((event, index) => {
              const { date, day, month } = formatDateParts(event.date);
              return (
              <div key={event._id || `${event.title}-${index}`}>
                <div className="event-item">
                  <div className="event-date-section">
                    <div className="event-date-stack">
                      <span className="event-date">{date}</span>
                      <span className="event-mnth">{month}</span>
                    </div>
                    <div className="event-datetime">
                      <h3 className="event-day">{day}</h3>
                      <p className="event-time">
                        {formatTime(event.time)}
                      </p>
                    </div>
                  </div>
                  
                  <div className="event-description">
                    {event.shortDescription || event.description || ''}
                  </div>
                  
                  <div className="event-vertical-line"></div>
                  
                  <div className="event-venue-section">
                    <h4 className="event-venue">{event?.venue}</h4>
                    <h4 className="event-venue">{event?.city}</h4>
                    <button
                      className="book-btn"
                      type="button"
                      onClick={() => handleBookSlot(event._id)}
                      disabled={!event._id}
                    >
                      Book Your Slot Now
                    </button>
                  </div>
                </div>
                {index < events.length - 1 && <div className="event-divider"></div>}
              </div>
            )})}
          </div>
        </div>

        <a href="/events" className="see-all-btn">See All Events</a>
      </div>
    </section>
  );
}

export default Upcomingevent;
